import axios from "axios";


function handleRequest(request, dialog, resolve, reject) {
  axios(request).then((response) => {
    dialog.loading = false;
    dialog.visible = false;
    resolve(response);
  }).catch((error) => {
    if (error.response !== undefined) {
      dialog.isAlert = true;
      dialog.loading = false;
      if (error.response.status === 400) {
        let e = error.response.data;
        if (Array.isArray(e)) {
          dialog.errorMessage = e.join(",");
        } else {
          dialog.errorMessage = e;
        }
      } else {
        dialog.errorMessage = "不明なエラーが発生しました。";
      }
    }
    reject(error);
  });
}

/**
    request =  axiosのconfigオブジェクト
    dialog = 下記の属性をもったオブジェクト
        {
            isAlert: false,
            errorMessage: "",
            visible: false,
            loading: false,
        }
    validator = validar関数オブジェクト

     */
export const executeRequest = function (request, dialog, validator = undefined) {
  return new Promise(function (resolve, reject) {
    dialog.isAlert = false;
    dialog.errorMessage = "";
    dialog.loading = true;
    if (validator !== undefined) {
      validator((valid) => {
        if (!valid) {
          dialog.loading = false;
          return false;
        } else {
          handleRequest(request, dialog, resolve, reject);
        }
      })
    } else { // validator無しの場合
      handleRequest(request, dialog, resolve, reject);
    }
  });
}
